export enum ContentBundleName {
  PDL = 'pdl_rb',
  PDF = 'pdf_rb',
  GLOBAL = 'global',
  LOGO = 'logo',
}

export interface ContentBundleManifest {
  public: {
    [lang: string]: { [bundle in ContentBundleName]: string };
  };
  customizations: {
    [brandingId: string]:
      | {
          [lang: string]:
            | { [bundle in ContentBundleName]: string | undefined }
            | undefined;
        }
      | undefined;
  };
}
